<div class="star-rating" role="radiogroup" aria-label="Valutazione in stelle">
  @for (star of [].constructor(stars); track star; let i = $index) {
    <span
      class="star"
      role="radio"
      [attr.aria-checked]="rating === i + 1"
      [attr.aria-posinset]="i + 1"
      [attr.aria-setsize]="stars"
      [attr.data-rating]="i + 1"
      [attr.tabindex]="rating === 0 ? (i === 0 ? 0 : -1) : (rating === i + 1 ? 0 : -1)"
      [attr.aria-label]="'Valuta ' + (i + 1) + ' stelle'"
      (click)="setRating(i + 1)"
      (keydown)="handleKeydown($event, i + 1)"
      (mouseenter)="setHover(i + 1)"
      (mouseleave)="clearHover()"
      [style.color]="hovered > 0 ? (i < hovered ? 'gold' : '#D9D9D9') : getColor(i)"
    >
      ★
    </span>
  }
</div>
